import {BaseSearchableService} from "./Core/BaseSearchableService";

class ConservationActionService extends BaseSearchableService {
    get Url() { return super.Url + "/conservationActions"; }
    get ModelName() { return "Conservation Action"; }
    get PrimaryKeyProperty() { return "conservationActionId"; }
    GetTitle(model) {
        return model?.ContextNodeDetails?.name;
    }

    GetConservationActionsForProjectId(projectId) {
        let request = {projectId: projectId};

        return this.SendRequest(BaseSearchableService.GET, request);
    }
}

export const service = new ConservationActionService();

